<template>
  <div id="sb-footer">
    <div
      class="gray-550 f-90 d-flex flex-row flex-wrap align-items-center justify-content-center justify-content-md-end footer mb-3"
    >
      <span class="text-white mr-2">powered by</span>
      <a href="https://qesg.co.kr/" style="color: #c883ff">ESG Reporting Tool</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SbFooter'
};
</script>

<style scoped>
#sb-footer {
  position: relative;
  width: 100%;
  z-index: 1000;
  margin-bottom: 1rem;
}
</style>
